module.exports = __webpack_public_path__ + "static/media/pet001.127165c1.jpg";